"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { commonFormFields, commonValidationRules } from "@/libs/builder/common/formFields";
import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const formTextAreaInputs = [...commonFormFields, ...commonValidationRules] as const satisfies Inputs;

export const FormTextAreaComponent: RegisteredComponent = {
  name: "FormTextArea",
  component: dynamic(async () =>
    withValidation(formTextAreaInputs, (await import("./FormTextArea")).FormTextArea, "FormTextArea")
  ),
  inputs: formTextAreaInputs,
};
